export const MAX_32_BIT_INTEGER = 2147483647;
